import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'global_redirection_title',
    defaultMessage: 'Ahorra tiempo con Trovit',
  },
  subtitle: {
    id: 'global_redirection_subtitle',
    defaultMessage: 'Te estamos redirigiendo al anuncio seleccionado...',
  },
  link: {
    id: 'global_redirection_link',
    defaultMessage: 'Entendido. No volver a mostrar',
  },
  platinumTitle: {
    id: 'global_insert_ad_platinum',
    defaultMessage: 'Post your ad on one of our partner sites',
    description: 'jobs',
  },
  platinumText: {
    id: 'global_text_publish_platinum',
    defaultMessage:
      "Trovit is a search engine, so you can't post your ad directly on our site. However, you can post your ad on one of our partner sites that do allow this and your ad will automatically be added to Trovit within 24 hours. We recommend this site:",
    description: 'jobs',
  },
  platinumLoading: {
    id: 'global_connecting_publish',
    defaultMessage: 'connecting with {%s} ...',
    description: 'jobs',
  },
  platinumLink: {
    id: 'global_redirect_publish',
    defaultMessage: "Click here if you're not redirected to {%s} in {%d} seconds",
    description: 'jobs',
  },
});



// WEBPACK FOOTER //
// ./app/Sources/redirectingTo/components/RedirectingToLayout/messages.js